import React from 'react';
import classNames from 'classnames/bind';
import PropTypes from 'prop-types';

import {
  VOTE_COOKIE_NAME,
  VOTE_FORM_STATE_ACTIVE,
  VOTE_FORM_STATE_ALREADY,
  VOTE_FORM_STATE_RESULTS,
} from 'store/widgets/VoteForm/constants';
import { getCookie } from 'utils/cookie';

import BackgroundImageContainer from '../../bricks/BackgroundImageContainer';
import styles from './styles.pcss';
import { ShowResultsFormView, VoteFormView } from './views';

const cx = classNames.bind(styles);
// ===
const FormViewSwitch = ({ isMobile, resultsData, viewState, votingData }) => {
  switch (viewState) {
    case VOTE_FORM_STATE_ACTIVE:
      return <VoteFormView {...{ ...votingData, isMobile }} />;
    case VOTE_FORM_STATE_RESULTS:
      return <ShowResultsFormView {...{ ...resultsData, isMobile }} />;
    default:
      return <VoteFormView {...{ ...votingData, isMobile }} />;
  }
};

FormViewSwitch.propTypes = {
  isMobile: PropTypes.bool,
  resultsData: PropTypes.shape({
    answers: PropTypes.arrayOf(
      PropTypes.shape({
        answerId: PropTypes.string,
        answerText: PropTypes.string,
      }),
    ),
    message: PropTypes.string,
    results: PropTypes.arrayOf(
      PropTypes.shape({
        answerId: PropTypes.string,
        rate: PropTypes.number,
      }),
    ),
    totalRate: PropTypes.number,
  }),
  viewState: PropTypes.string,
  voteSuccessData: PropTypes.shape({
    heading: PropTypes.string,
    /* redux-connected props */
    onSuccessSubmit: PropTypes.func,
    question: PropTypes.string,
    subscribeWidgetData: PropTypes.shape({
      backgroundUrl: PropTypes.string,
      className: PropTypes.string,
      emailInvalidMessage: PropTypes.string,
      errorData: PropTypes.any,
      /* virtual field passed by reduxForm */
      form: PropTypes.string, // form name for redux
      handleSubmit: PropTypes.func,
      /* inherit props */
      id: PropTypes.string, // required for unification 2 or more form on 1 page
      initData: PropTypes.shape({
        buttonText: PropTypes.string,
        description: PropTypes.string,
        heading: PropTypes.string,
        headingTagName: PropTypes.string,
        isColumn: PropTypes.bool,
        markup: PropTypes.any,
      }),
      initialize: PropTypes.func, // initialize values for the form
      /* it's named Unchecked, cause toogling starts from value - true */
      isAgreementUnchecked: PropTypes.bool,
      /* redux-connected-props */
      isMobile: PropTypes.bool,
      onEmailValidate: PropTypes.func,
      onSendSubscribe: PropTypes.func,
      onSubmitSubscribe: PropTypes.func,
      onToogleAgreement: PropTypes.func,
      requiredFieldMessage: PropTypes.string,
      successData: PropTypes.shape({
        buttonText: PropTypes.string,
        description: PropTypes.string,
        heading: PropTypes.string,
        headingTagName: PropTypes.string,
        isColumn: PropTypes.bool,
        markup: PropTypes.any,
        openInNewTab: PropTypes.bool,
        redirectUrl: PropTypes.string,
      }),
      /* inherit from vote success data */
      widgetPosition: PropTypes.string,
    }),
    title: PropTypes.string,
    useSubscribe: PropTypes.bool,
    widgetPosition: PropTypes.string,
  }),
  votingData: PropTypes.shape({
    /* redux-connected props */
    activeOptionId: PropTypes.string,
    answers: PropTypes.arrayOf(
      PropTypes.shape({
        answerId: PropTypes.string,
        answerText: PropTypes.string,
      }),
    ),
    buttonText: PropTypes.string,
    heading: PropTypes.string,
    headingTagName: PropTypes.string,
    question: PropTypes.string,
  }),
};
// ===
export default class VoteFormWidgetLayout extends React.PureComponent {
  constructor(props) {
    super(props);
    const { isVotingActive } = props;
    this.state = {
      formRenderEnabled: !isVotingActive,
      formViewState: isVotingActive ? VOTE_FORM_STATE_ACTIVE : VOTE_FORM_STATE_RESULTS,
    };
  }

  componentDidMount() {
    const { formRenderEnabled } = this.state;
    if (!formRenderEnabled) {
      const isAlreadyVoted = !!getCookie(VOTE_COOKIE_NAME);
      this.changeFormViewState(isAlreadyVoted ? VOTE_FORM_STATE_ALREADY : VOTE_FORM_STATE_ACTIVE);
    }
  }

  changeFormViewState = (nextFormViewState, formRenderEnabled = true) =>
    this.setState({ formRenderEnabled, formViewState: nextFormViewState });

  render() {
    const {
      backgroundUrl,
      className,
      id,
      isMobile,
      results,
      subscribeWidgetData,
      thankYou,
      useSubscribe,
      voting,
      widgetPosition,
    } = this.props;
    // ===
    const { answers, question } = voting || {};
    // ===
    const { formRenderEnabled, formViewState } = this.state;

    return (
      <div className={cx('voteForm')} id={id}>
        <BackgroundImageContainer
          backgroundClassName={cx('voteBackground')}
          className={cx(className)}
          imageProps={{ className: cx('voteImage', isMobile && 'mobile') }}
          src={backgroundUrl}
        >
          <div className={cx('voteContent', isMobile && 'mobile')}>
            {formRenderEnabled && (
              <FormViewSwitch
                viewState={formViewState}
                {...{
                  isMobile,
                  resultsData: {
                    ...results,
                    answers,
                  },
                  voteSuccessData: {
                    ...thankYou,
                    question,
                    subscribeWidgetData,
                    useSubscribe,
                    widgetPosition,
                  },
                  votingData: {
                    ...voting,
                    formViewChange: () => {
                      this.changeFormViewState(VOTE_FORM_STATE_ALREADY);
                    },
                  },
                }}
              />
            )}
          </div>
        </BackgroundImageContainer>
      </div>
    );
  }
}

VoteFormWidgetLayout.propTypes = {
  backgroundUrl: PropTypes.string,
  className: PropTypes.string,
  /* inherit props */
  id: PropTypes.string, // required for unification 2 or more form on 1 page
  /* redux-connected-props */
  isMobile: PropTypes.bool,
  isVotingActive: PropTypes.bool,
  results: PropTypes.shape({
    message: PropTypes.string,
    results: PropTypes.arrayOf(
      PropTypes.shape({
        answerId: PropTypes.string,
        rate: PropTypes.number,
      }),
    ),
    totalRate: PropTypes.number,
  }),
  subscribeWidgetData: PropTypes.shape({
    backgroundUrl: PropTypes.string,
    className: PropTypes.string,
    emailInvalidMessage: PropTypes.string,
    errorData: PropTypes.any,
    /* virtual field passed by reduxForm */
    form: PropTypes.string, // form name for redux
    handleSubmit: PropTypes.func,
    /* inherit props */
    id: PropTypes.string, // required for unification 2 or more form on 1 page
    initData: PropTypes.shape({
      buttonText: PropTypes.string,
      description: PropTypes.string,
      heading: PropTypes.string,
      headingTagName: PropTypes.string,
      isColumn: PropTypes.bool,
      markup: PropTypes.any,
    }),
    initialize: PropTypes.func, // initialize values for the form
    /* it's named Unchecked, cause toogling starts from value - true */
    isAgreementUnchecked: PropTypes.bool,
    /* redux-connected-props */
    isMobile: PropTypes.bool,
    onEmailValidate: PropTypes.func,
    onSendSubscribe: PropTypes.func,
    onSubmitSubscribe: PropTypes.func,
    onToogleAgreement: PropTypes.func,
    requiredFieldMessage: PropTypes.string,
    successData: PropTypes.shape({
      buttonText: PropTypes.string,
      description: PropTypes.string,
      heading: PropTypes.string,
      headingTagName: PropTypes.string,
      isColumn: PropTypes.bool,
      markup: PropTypes.any,
      openInNewTab: PropTypes.bool,
      redirectUrl: PropTypes.string,
    }),
  }),
  thankYou: PropTypes.shape({
    heading: PropTypes.string,
    title: PropTypes.string,
  }),
  useSubscribe: PropTypes.bool,
  voting: PropTypes.shape({
    /* redux-connected props */
    activeOptionId: PropTypes.string,
    answers: PropTypes.arrayOf(
      PropTypes.shape({
        answerId: PropTypes.string,
        answerText: PropTypes.string,
      }),
    ),
    buttonText: PropTypes.string,
    heading: PropTypes.string,
    headingTagName: PropTypes.string,
    question: PropTypes.string,
  }),
  widgetPosition: PropTypes.string,
};

VoteFormWidgetLayout.defaultProps = {
  id: 'voteForm',
};
